// extracted by mini-css-extract-plugin
module.exports = {"text":"text___3jAhj","avatar":"avatar___LarZx","operation":"operation___2Atnh","titleRequired":"title-required___2sHjo","disabled":"disabled___39jCJ","error":"error___4aCzO"};